package com.sweetlime.dungeonamigo.util

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

// On Kotlin/JS, Long is a boxed object — not a native JS number.
// The gitlive Firestore encoder stores it as-is, which the Firebase JS SDK
// cannot serialize. This serializer writes Long as Double (which JS natively
// understands) without losing precision for values within ±2^53.
object LongAsDoubleSerializer : KSerializer<Long> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("LongAsDouble", PrimitiveKind.DOUBLE)

    override fun serialize(encoder: Encoder, value: Long) =
        encoder.encodeDouble(value.toDouble())

    override fun deserialize(decoder: Decoder): Long =
        decoder.decodeDouble().toLong()
}